// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ScanQrCode-module-scanQrContainer-\\+dW7b{display:block}.ScanQrCode-module-scanQrContainer-\\+dW7b svg{color:var(--des-color-fill-glyph-on-top-of-accent-panel);width:var(--des-dimension-gap-and-padding-button-bezeled-primary-and-secondary-small-icon-height-width);height:var(--des-dimension-gap-and-padding-button-bezeled-primary-and-secondary-small-icon-height-width)}@media(min-width: 768px){.ScanQrCode-module-scanQrContainer-\\+dW7b{display:none}}.ScanQrCode-module-scanQrButton-rA0Ax{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scanQrContainer": "ScanQrCode-module-scanQrContainer-+dW7b",
	"scanQrButton": "ScanQrCode-module-scanQrButton-rA0Ax"
};
export default ___CSS_LOADER_EXPORT___;
